import React, {useState} from 'react';
import '../styling/containerStyles.css'
import Label from '../components/label'
import ButtonComp from '../components/button'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '../components/button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
interface PreviousBankDetailsProps{
    handleToProceed:Function;
    previouslyAddedBankTransaction:Function;
    removePreiouslyAddedBanks:Function;
    previousBankDetails: any,
    amount: any;
    prevBankType: any;
    bonusAmount: any;
}

export const PreviousBankDetails: React.FC<PreviousBankDetailsProps> = (props: PreviousBankDetailsProps) =>{

    const{
        handleToProceed, previousBankDetails, amount, prevBankType, previouslyAddedBankTransaction, removePreiouslyAddedBanks, bonusAmount
    } = props;

    console.log("bank details", props);

    
    const [value, setValue] = useState('')
   
    const handleClick = (option: any) => {
        // if(option === 'GoBack'){
        //     handleToProceed(option)
        // }
        setValue('');
        if(amount !== '') {
            handleToProceed(prevBankType, amount, "AddNew", bonusAmount)
        }
    }

    const handleClickProceed = (option: any) => {
        if(value !== '') {
            previouslyAddedBankTransaction(value, "from_old_bank")
        }
    }
     
    const handleRadioChange = (event: any) => {
        let val = event.target.value;
        setValue(val)
    };

    const handleDelete = (event: any, c: any) => {
        removePreiouslyAddedBanks(c)
    }
    
    return (
        <div className= "previous_bank_details">
        <div className='success_transaction_listing'>
            <hr>
            </hr>

            <div className='briefing'>
                <div className='leftBox'>
                    <Label content="Account History" />
                    <div className='subtext'>Your already used bank account details</div>
                </div>

            </div>
            <hr>
            </hr>


            <div className="previous_bank_lists">
                <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> 
                    {previousBankDetails.map((c:any, i:number) => {
                        return(
                    <>
                    <FormControlLabel value={c.uuid} control={<Radio />} label={
                        <section className='menuItem'>
                            {/* <img className='payLogo' src = {paytmLogo} alt='paytm' ></img> */}
                            <div className='payOption'>
                                <div className='payName'>{c.name} </div>
                                {/* <div className='paySubName'>{c.number} </div> */}
                            </div>
                            <IconButton id={c.uuid} aria-label="delete" onClick={e => handleDelete(e, c.uuid)}>
                                    <DeleteIcon />
                            </IconButton>
                        </section>
                    }
                    /></>)})}
                    </RadioGroup>
                </div>

        </div>
        <div className='suc' id="add box">
            <ButtonComp label= {'AddNew'} 
                name={'Add New Bank Account'} 
                visible={true}
                handleToUpdate={handleClick} />
        </div>
        <div className={value ? 'suc previous_bank_btn' : 'suc previous_bank_btn_disable'} id="proceed box">
        <Button label= {'Proceed'} 
            name={'PROCEED'} 
            visible={true}
            disabled={value ? false : true}
            handleToUpdate={handleClickProceed}  />
        </div>
        </div>
    )
    }


    export default PreviousBankDetails